import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import _ from "lodash"
import {Collapse, FormFeedback} from 'reactstrap'
import {useFormContext} from 'react-hook-form'
import classnames from "classnames"

import {trans} from "@utils"
import InputContainer from "@src/components/helpers/InputContainer"
import CustomFormGroup from "@src/components/helpers/CustomFormGroup"

const Decimal = props => {
  const {data} = props
  const {watch, errors, control, setValue, getValues} = useFormContext()

  const numbers = _.times(17, x => ({label: x, value: x}))
  const watchMaxDigitsNumber = watch('config.max_digits')

  useEffect(() => {
    if (getValues("config.decimals")?.value && watchMaxDigitsNumber?.value) {
      if (parseInt(getValues("config.decimals")?.value) >= watchMaxDigitsNumber?.value) {
        setValue("config.decimals", _.first(numbers))
      }
    }
  }, [watchMaxDigitsNumber])

  return (
   <>
     <CustomFormGroup name={"config.max_digits"} title={trans('customFields.maxDigitsAllowed')}>
       <InputContainer
         control={control}
         name={`config.max_digits`}
         type={"select"}
         classNamePrefix={'select'}
         className={classnames('react-select', {
           "is-invalid": _.get(errors, `config.max_digits`)
         })}
         // placeholder={""}
         options={_.filter(numbers, x => x.value > 0)}
         rules={{
           required: trans('gen.validations.required')
         }}
         defaultValue={_.get(data, `config.max_digits`) > 0 ? _.find(numbers, x => x.value === _.get(data, `config.max_digits`)) : _.last(numbers)}
       />
       {_.get(errors, `config.max_digits`) && <FormFeedback> {_.get(errors, `config.max_digits.message`)} </FormFeedback>}
     </CustomFormGroup>
     <CustomFormGroup name={"config.decimals"} title={trans('customFields.numberOfDecimalPlaces')}>
       <InputContainer
         control={control}
         name={`config.decimals`}
         type={"select"}
         classNamePrefix={'select'}
         className={classnames('react-select', {
           "is-invalid": _.get(errors, `config.decimals`)
         })}
         // placeholder={""}
         options={_.filter(_.filter(numbers, x => x?.value < 10), x => x?.value < watchMaxDigitsNumber?.value)}
         rules={{
           required: trans('gen.validations.required')
         }}
         defaultValue={_.get(data, `config.decimals`) > 0 ? _.find(numbers, x => x.value === _.get(data, `config.decimals`)) : _.first(numbers)}
       />
       {_.get(errors, `config.decimals`) && <FormFeedback> {_.get(errors, `config.decimals.message`)} </FormFeedback>}
     </CustomFormGroup>
   </>
  )
}

Decimal.propTypes = {}

export default Decimal